/** Shared reveal-host props — host div only, no component-children seam. */
export function revealHostProps(delay: number) {
  return {
    className: "reveal",
    style: { animationDelay: delay.toFixed(3) + "s" },
    onAnimationEnd: (e: any) => {
      if (e.target !== e.currentTarget) return;
      const el = e.currentTarget;
      el.style.animation = "none";
      el.style.opacity = "1";
      el.style.transform = "none";
    },
  };
}
